import { useTranslation } from 'react-i18next'

import { Button, Dialog, IconButton, Stack, Tooltip } from '@mui/material'
import PowerSettingsNewRoundedIcon from '@mui/icons-material/PowerSettingsNewRounded'

import { Room } from '@/core/models/room.model'
import { EfficienceWebDialog } from '@/features/dmp-connect'
import { useDialogState } from '@/hooks/useDialogState'
import { useIsPds } from '@/hooks/useStaffRole'
import Sidebar from '@/layouts/diagnostic/Sidebar'
import Documents from '@/pages/diagnostic/containers/Documents'

import { useEndEmergencyConsultation } from '../model/useEndEmergencyConsultation'
import { EmergencySidebarMenuItem, UseEmergencySidebarMenuReturn } from '../model/useEmergencySidebarMenu'

type EmergencySidebarProps = {
  emergencyRoom: Room
  sidebarMenuItems: UseEmergencySidebarMenuReturn['sidebarMenuItems']
  selectedSidebarMenuItem: UseEmergencySidebarMenuReturn['selectedSidebarMenuItem']
  setSelectedSidebarMenuItem: UseEmergencySidebarMenuReturn['setSelectedSidebarMenuItem']
}
export function EmergencySidebar({ emergencyRoom, sidebarMenuItems, selectedSidebarMenuItem, setSelectedSidebarMenuItem }: EmergencySidebarProps) {
  const isPds = useIsPds()
  const { t } = useTranslation()

  const { endConsultation } = useEndEmergencyConsultation(emergencyRoom)

  const { dialogState, setDialogState, closeDialog } = useDialogState<EmergencySidebarMenuItem.DOCUMENTS>('none')

  const handleSelectSidebarMenuItem = (id: string) => {
    switch (id) {
      case EmergencySidebarMenuItem.DMP:
        window.open(`/efficience-web?consultationId=${emergencyRoom.currentConsultation}`, '_blank')
        return
      case EmergencySidebarMenuItem.MSS:
        window.open(`/efficience-web?consultationId=${emergencyRoom.currentConsultation}&mode=mss`, '_blank')
        return
      case EmergencySidebarMenuItem.DOCUMENTS:
        setDialogState(id)
        return
      default:
        setSelectedSidebarMenuItem(id as EmergencySidebarMenuItem)
        return
    }
  }

  return (
    <>
      <Sidebar
        menuItems={sidebarMenuItems}
        onSelect={handleSelectSidebarMenuItem}
        renderFooter={({ expanded }) =>
          isPds ? (
            <Stack alignItems="center" justifyContent="center" sx={{ height: '60px', p: '14px 10px' }}>
              {expanded ? (
                <Button color="error" onClick={endConsultation} variant="contained">
                  {t('page.emergency.finishConsultationButton.label')}
                </Button>
              ) : (
                <Tooltip arrow placement="right" title={t('page.emergency.finishConsultationButton.tooltip')}>
                  <IconButton onClick={endConsultation}>
                    <PowerSettingsNewRoundedIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
          ) : null
        }
        selectedMenuItem={selectedSidebarMenuItem}
      />
      <Dialog open={dialogState === EmergencySidebarMenuItem.DOCUMENTS} onClose={closeDialog}>
        <Documents consultationId={emergencyRoom.currentConsultation} />
      </Dialog>
    </>
  )
}
